import { render, staticRenderFns } from "./FileResult.vue?vue&type=template&id=713a9374&scoped=true"
import script from "./FileResult.ts?vue&type=script&lang=ts&external"
export * from "./FileResult.ts?vue&type=script&lang=ts&external"
import style0 from "./FileResult.vue?vue&type=style&index=0&id=713a9374&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713a9374",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('713a9374')) {
      api.createRecord('713a9374', component.options)
    } else {
      api.reload('713a9374', component.options)
    }
    module.hot.accept("./FileResult.vue?vue&type=template&id=713a9374&scoped=true", function () {
      api.rerender('713a9374', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Uploader/components/FileResult/FileResult.vue"
export default component.exports